const initState = {
  Adding: null,
  AddError: null,
  Add: null,
};

const slideshowPhotoReducer = (state = initState, action) => {
  switch (action.type) {
    case "SLIDESHOW_ADDING":
      return {
        ...state,
        Adding: true,
        AddError: null,
        Add: false,
      };
    case "SLIDESHOW_ADDED":
      return {
        ...state,
        Adding: null,
        AddError: null,
        Add: true,
      };
    case "SLIDESHOW_ADD_CLEAR_STATUS":
      return {
        ...state,
        Adding: null,
        AddError: null,
        Add: null,
      };
    case "SLIDESHOW_ADD_ERROR":
      return {
        ...state,
        Adding: null,
        AddError: action.err,
        Add: false,
      };
    default:
      return state;
  }
};
export default slideshowPhotoReducer;
